import config from '@/config'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../../../../credit-route-config'

export const Route = createFileRoute(
  '/_auth/_modules/credit/admin/users/delegation-of-authority/initiative',
)({
  staticData: toStaticData(CREDIT_ROUTES['/credit/admin/users/delegation-of-authority/initiative']),
  beforeLoad: async ({ context }) => {
    // The initiative chain's DOA has nothing to configure while the feature is off.
    if (!config.featureFlags.initiatives) {
      throw redirect({ to: '/credit/admin/users/delegation-of-authority' })
    }
    context.handleRoutePermissions(Route)
  },
})
